import BaseApi from '@/api/Base/BaseApi'
import {
  CreateImageMatchingNodePayload,
  GenerateMatchingPairsPayload,
  GenerateMatchingPairsResponse,
  GetImageMatchingNodeItemsPayload,
  GetImageMatchingNodeItemsResponse,
  ImageMatchingNodeInfo,
  UpdateImageMatchingNodePayload
} from '@/api/ImageMatchingNode/types'
import { omitNilOrEmptyStringFromObject } from '@/utils/common'

const ROOT = '/image-matching'

export default class ImageMatchingNodeApi extends BaseApi {
  createImageMatchingNode(payload: CreateImageMatchingNodePayload) {
    const { projectId, ...rest } = payload
    return this.agent.post<ImageMatchingNodeInfo>(`/project/${projectId}/image-matching/create`, rest)
  }

  updateImageMatchingNode(payload: UpdateImageMatchingNodePayload) {
    const { imageMatchingNodeId, name, ...rest } = payload
    return this.agent.put<ImageMatchingNodeInfo>(`${ROOT}/${imageMatchingNodeId}`, { ...rest, name: name?.trim() })
  }

  deleteImageMatchingNode(imageMatchingNodeId: string) {
    return this.agent.delete(`${ROOT}/${imageMatchingNodeId}`)
  }

  getImageMatchingNodeDetail(imageMatchingNodeId: string) {
    return this.agent.get<ImageMatchingNodeInfo>(`${ROOT}/${imageMatchingNodeId}`)
  }

  getImageMatchingNodeItems(payload: GetImageMatchingNodeItemsPayload) {
    const {
      imageMatchingNodeId,
      itemsPerPage,
      sortKey,
      sortDir,
      ...rest
    } = payload
    const params = omitNilOrEmptyStringFromObject({
      num_per_page: itemsPerPage ?? 100,
      sort_key: sortKey,
      sort_dir: sortDir,
      ...rest,
    })
    return this.agent.get<GetImageMatchingNodeItemsResponse>(`${ROOT}/${imageMatchingNodeId}/list`, { params })
  }

  generateMatchingPairs(payload: GenerateMatchingPairsPayload) {
    const { imageMatchingNodeId, ...rest } = payload
    return this.agent.post<GenerateMatchingPairsResponse>(`${ROOT}/${imageMatchingNodeId}/auto-matching`, rest)
  }
}
